import { BlocksIconSupportHeadphones } from 'blocks-nextjs/blocks-web-components/components/icon/icons/support-headphones';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconSupportHeadphones = createComponent({
  react: React,
  tagName: 'cat-icon-support-headphones',
  elementClass: BlocksIconSupportHeadphones
});
